'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { Footer } from '@/src/components/Footer/Footer';
import { Header } from '@/src/components/Header/Header';
import { GDPRPopup } from '@/src/components/Popup';
import { WebinarRibbon } from '@/src/components/WebinarRibbon/WebinarRibbon';
const WebsiteLayout = t0 => {
  const $ = _c(18);
  const {
    children
  } = t0;
  const [displayShadow, setDisplayShadow] = useState(false);
  const [ribbonVisible, setRibbonVisible] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setDisplayShadow(window.scrollY > 250);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleScroll = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = visible => {
      setRibbonVisible(visible);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleRibbonVisibility = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <WebinarRibbon onVisibilityChange={handleRibbonVisibility} />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== displayShadow || $[6] !== ribbonVisible) {
    t6 = <Header displayShadow={displayShadow} ribbonVisible={ribbonVisible} />;
    $[5] = displayShadow;
    $[6] = ribbonVisible;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <GDPRPopup />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = ribbonVisible ? "44px" : "0";
  let t9;
  if ($[9] !== t8) {
    t9 = {
      paddingTop: t8
    };
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== children || $[12] !== t9) {
    t10 = <main style={t9}>{children}</main>;
    $[11] = children;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Footer />;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t6) {
    t12 = <>{t5}{t6}{t7}{t10}{t11}</>;
    $[15] = t10;
    $[16] = t6;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
};
export default WebsiteLayout;